import { Loading, WithNativeHTMLProps } from "@kalyzee/kast-web-sdk/web-components";
import React, { ForwardedRef, useMemo } from "react";
import styles from "./LoadingView.module.css";
import "./LoadingView.css";

export interface LoadingViewProps extends WithNativeHTMLProps<HTMLDivElement> {
  dark?: boolean;
  message?: string;
  className?: string;
  style?: React.CSSProperties;
}

export interface LoadingViewRef {}

export const LoadingView = React.forwardRef(({ dark, message, className, style, ...nativeProps }: LoadingViewProps, forwardRef: ForwardedRef<LoadingViewRef | undefined>) => {
  const classes = useMemo(() => {
    const classes = [styles.container];
    if (className) classes.push(className);
    if (dark) classes.push(styles.dark);
    return classes.join(" ");
  }, [className, dark]);
  return (
    <div {...nativeProps} className={classes} style={style}>
      <Loading message={message ?? "Chargement en cours"} />
    </div>
  );
});
